<template lang='pug'>
.main-container

  .view-content
    el-card
      div(slot='header')
        i.mat-icon assignment_turned_in
        | Orders
      el-tabs( v-model='activeIndex', type='card' )
        el-row(:gutter='10')
          el-col(:span='9')
            el-input(v-model='sorting' prefix-icon="el-icon-search" placeholder="Search")

        el-tab-pane(
          v-for='filter in filters' :label='$upcaseFirst(filter)',
          :name='filter', :key='filter'
        )
          order-list(:filter='filter', :sorting='sorting', v-if='filter == activeIndex')
      //-
      //- el-table(:data='orders', v-loading='orders == null')
      //-   el-table-column(label='Total')
      //-     template(slot-scope='scope')
      //-       | {{$formatCents(scope.row.total_cents)}}
      //-   el-table-column(label='Invoice', prop='stripe_invoice_id')
      //-   el-table-column(label='Estimate', prop='estimate_id')
      //-   el-table-column(label='Status', prop='status')
      //-   el-table-column(label='Actions')
      //-     template(slot-scope='scope')
      //-       el-button(type='text' size='small', @click='$message("Pending wiring")') Track
    router-view
</template>

<script>

  import OrderList from './blocks/OrderList.vue'

  function data(){
    return {
      filters: ['open', 'closed'],
      sorting:'',
      orders: null,
      activeIndex: 'open',
      loadingOrders: true,
      loadingContacts: true
    }
  }

  function getOrders(){
    this.loadingOrders = true
    return this.$simplecater.get('/orders').then((r)=> {
      this.orders = r.data.data
      this.loadingOrders = false
    })
  }

  // function goToAddressBuilder(){
  //   this.$message("Pending wiring")
  //   //this.$router.push("/user/orders/new")
  // }
  //
  //
  // function goToContactBuilder(){
  //   this.$message("Pending wiring")
  //   //this.$router.push("/user/orders/new")
  // }

  function created(){
    this.getOrders()
  }

  const watch = {
    '$route' (to, from) {
      console.log("Reloading data")
      this.getOrders()
    }
  }

  const components = { OrderList }

  const methods = {
    getOrders
  }

  export default { methods, components, data, created }

</script>



// WEBPACK FOOTER //
// src/user/Orders.vue